import introductionWorld from "../Assets/data/worlds/introductions.json";
import keyTermsWorld from "../Assets/data/worlds/keyTerms.json";
import pubertyHealthWorld from "../Assets/data/worlds/pubertyHealthGenderExploration.json";
import socialTransitionWorld from "../Assets/data/worlds/socialTransition.json";
import medicalTransitionWorld from "../Assets/data/worlds/medicalTransition.json";
import legalTransitionWorld from "../Assets/data/worlds/legalTransition.json";
import sexEducationWorld from "../Assets/data/worlds/sexEducation.json";
import stbbiWorld from "../Assets/data/worlds/stbbi.json";
import mentalHealthWorld from "../Assets/data/worlds/mentalHealth.json";
import communityConnectionsWorld from "../Assets/data/worlds/communityConnections.json";

const worldsArray = [
  introductionWorld,
  keyTermsWorld,
  pubertyHealthWorld,
  socialTransitionWorld,
  medicalTransitionWorld,
  legalTransitionWorld,
  sexEducationWorld,
  stbbiWorld,
  mentalHealthWorld,
  communityConnectionsWorld,
];

export const parseYesResources = (instruction) => {
  const regex = /@Yes\{([0-9, ]+)\}/;
  const match = instruction.match(regex);
  return match ? match[1].split(",").map(Number).filter(Boolean) : [];
};

export const extractResources = (inputString) => {
  const initialSplit = inputString.split("@resources{")[1];
  const regex = /@?([^{]+)\{([^}]+)\}/g;
  let match;
  const results = [];
  while ((match = regex.exec(initialSplit)) !== null) {
    const resourceString = `${match[1].trim()}{${match[2].trim()}}`;
    results.push(resourceString);
  }
  return results;
};

export const parseSpecialResources = (resources, selections) => {
  const ids = [];
  if (Array.isArray(resources)) {
    resources.forEach((resource) => {
      selections.forEach((selection) => {
        if (resource.startsWith(selection)) {
          const extractedIds = resource
            .match(/\{([^}]+)\}/)[1]
            .split(", ")
            .map(Number);
          ids.push(...extractedIds);
        }
      });
    });
  }
  return ids;
};

export const getAllDialogues = (worldOrder) => {
  return worldsArray[worldOrder].dialogues.map((dialogue, index) => {
    dialogue._id = index;
    dialogue.world = worldOrder;
    dialogue.options = dialogue.options.map((option, optionIndex) => {
      option._id = optionIndex;
      return option;
    });
    return dialogue;
  });
};

export const getAllWorlds = () => {
  return worldsArray.map(({ dialogues, ...rest }) => rest);
};

export const getWorld = (worldOrder) => {
  return worldsArray[worldOrder];
};
